export const getCheckedContractsIds = (allContracts: Contract[]): number[] => {
  const ids: number[] = [];

  allContracts.filter(
    contract => contract.checked === true && ids.push(contract.id)
  );

  return ids;
};
